import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { formatMoney } from "@/lib/format";
import { useT } from "@/lib/i18n";

const COLORS = ["#059669", "#2563eb", "#d97706", "#7c3aed", "#e11d48", "#0891b2"];

export default function DistributionChart({ data, currency, subtitle }) {
  const { t } = useT();
  const chartData = (data || []).map((d, i) => ({ ...d, color: COLORS[i % COLORS.length], value: d.percent }));

  return (
    <div className="rounded-xl border border-slate-200/80 bg-white p-5 shadow-[0_1px_3px_0_rgba(15,23,42,0.04)]" data-testid="distribution-panel">
      <h3 className="text-lg font-semibold text-slate-900">{t("dash.distribution")}</h3>
      {subtitle && <p className="mb-4 text-xs text-slate-500">{subtitle}</p>}
      {chartData.length === 0 ? (
        <p className="py-10 text-center text-sm text-slate-400">Aucune donnée sur la période</p>
      ) : (
        <div className="flex flex-col items-center gap-5 sm:flex-row">
          <div className="relative h-40 w-40 shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={chartData} dataKey="value" innerRadius={52} outerRadius={72} paddingAngle={2} stroke="none">
                  {chartData.map((d) => <Cell key={d.category} fill={d.color} />)}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
              <span className="text-[10px] uppercase tracking-wide text-slate-400">Total</span>
              <span className="font-mono text-sm font-bold text-slate-900">100%</span>
            </div>
          </div>
          <div className="w-full space-y-2.5">
            {chartData.map((d) => (
              <div key={d.category} className="flex items-center gap-2.5" data-testid={`distribution-item-${d.category}`}>
                <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: d.color }} />
                <span className="flex-1 truncate text-sm text-slate-600">{d.label}</span>
                <span className="font-mono text-sm font-semibold text-slate-900">{d.percent}%</span>
                <span className="w-20 shrink-0 text-right font-mono text-xs text-slate-400">{formatMoney(d.value_cents, currency)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
